import { observable, runInAction, makeObservable } from 'mobx';
import { AppService } from './AppService';
import { NotificationService } from './NotificationService';
import { RequirementsExceptionsService } from './RequirementsExceptionsService';
import { SearchReportService } from './SearchReportService';

export interface IRootStore {
  appData?: AppService;
  requirementsExceptions?: RequirementsExceptionsService;
  notifications?: NotificationService;
  searchReport?: SearchReportService;
}

export class RootStore implements IRootStore {
  public appData?: AppService = undefined;

  public requirementsExceptions?: RequirementsExceptionsService = undefined;

  public notifications?: NotificationService = undefined;

  public searchReport?: SearchReportService = undefined;

  constructor() {
    makeObservable(this, {
      appData: observable,
      requirementsExceptions: observable,
      notifications: observable,
      searchReport: observable
    });

    runInAction(() => {
      this.notifications = new NotificationService();
      this.appData = new AppService();
      this.requirementsExceptions = new RequirementsExceptionsService(this.appData, this.notifications);
      this.searchReport = new SearchReportService(this.appData, this.notifications);
    });
  }
}
